const titles = [
	"Software Engineer",
	"Data Scientist",
	"Product Manager",
	"UX Designer",
	"Front-end Developer",
	"Back-end Developer",
	"Full Stack Developer",
	"Mobile App Developer",
	"DevOps Engineer",
	"Network Administrator",
	"Database Administrator",
	"Systems Analyst",
	"IT Project Manager",
	"Cybersecurity Analyst",
	"Business Analyst",
	"QA Tester",
	"Technical Writer",
	"UI Designer",
	"Graphic Designer",
	"Content Writer",
	"Digital Marketing Specialist",
	"SEO Specialist",
	"Social Media Manager",
	"Video Editor",
	"Animator",
	"Data Analyst",
	"Machine Learning Engineer",
	"Artificial Intelligence Specialist",
	"Blockchain Developer",
	"Cloud Solutions Architect",
	"IT Support Specialist",
	"Network Engineer",
	"Systems Administrator",
	"Database Developer",
	"IT Consultant",
	"Scrum Master",
	"Agile Coach",
	"Product Owner",
	"Project Coordinator",
	"Web Designer",
	"Mobile App Designer",
	"Game Developer",
	"IT Manager",
	"Technical Support Engineer",
	"Systems Engineer",
	"Business Intelligence Analyst",
	"User Researcher",
	"Interaction Designer",
	"Marketing Manager",
	"Sales Representative",
	"Account Manager",
	"Financial Analyst",
	"Human Resources Manager",
	"Operations Manager",
	"Supply Chain Analyst",
	"Logistics Coordinator",
	"Procurement Specialist",
	"Risk Analyst",
	"Compliance Officer",
	"Legal Counsel",
	"Business Development Manager",
	"Operations Analyst",
	"Customer Success Manager",
	"IT Auditor",
	"UI Developer",
	"Software Architect",
	"Data Engineer",
	"Product Analyst",
	"UX Researcher",
	"Front-end Designer",
	"Back-end Designer",
	"Mobile App Tester",
	"Security Analyst",
	"Data Entry Specialist",
	"Systems Architect",
	"Database Architect",
	"IT Trainer",
	"Network Administrator",
	"Data Modeler",
	"Quality Assurance Analyst",
	"Technical Recruiter",
	"UI/UX Developer",
	"Digital Strategist",
	"Content Strategist",
	"Copywriter",
	"SEO Analyst",
	"Social Media Specialist",
	"Videographer",
	"Motion Graphics Designer",
	"Business Data Analyst",
	"Big Data Engineer",
	"Cloud Engineer",
	"IT Analyst",
	"Network Analyst",
	"Web Developer",
	"Mobile App Developer",
	"Game Designer",
	"Product Marketing Manager",
	"Sales Manager",
	"Account Executive",
	"Financial Manager",
	"HR Business Partner",
	"Operations Coordinator",
	"Supply Chain Manager",
	"Logistics Manager",
	"Procurement Manager",
	"Compliance Manager",
	"Legal Advisor",
	"Business Analyst Manager",
	"Operations Manager",
	"Customer Service Manager",
	"IT Security Manager",
	"UI/UX Designer",
	"Software Developer",
	"Database Administrator",
	"Systems Analyst",
	"IT Project Manager",
	"Cybersecurity Analyst",
	"Business Analyst",
	"QA Analyst",
	"Technical Writer",
	"Graphic Designer",
	"Content Writer",
	"Digital Marketer",
	"SEO Specialist",
	"Social Media Manager",
	"Video Editor",
	"Animator",
	"Data Analyst",
	"Machine Learning Engineer",
	"AI Specialist",
	"Blockchain Developer",
	"Cloud Architect",
	"IT Support Specialist",
	"Network Engineer",
	"Systems Administrator",
	"Database Developer",
	"IT Consultant",
	"Scrum Master",
	"Agile Coach",
	"Product Owner",
	"Project Coordinator",
	"Web Designer",
	"Mobile App Designer",
	"Game Developer",
	"IT Manager",
	"Technical Support Engineer",
	"Systems Engineer",
	"BI Analyst",
	"User Researcher",
	"Interaction Designer",
	"Marketing Manager",
	"Sales Representative",
	"Account Manager",
	"Financial Analyst",
	"HR Manager",
	"Operations Manager",
	"Supply Chain Analyst",
	"Logistics Coordinator",
	"Procurement Specialist",
	"Risk Analyst",
	"Compliance Officer",
	"Legal Counsel",
	"Business Development Manager",
	"Operations Analyst",
	"Customer Success Manager",
	"IT Auditor",
	"UI Developer",
	"Software Architect",
	"Data Engineer",
	"Product Analyst",
	"UX Researcher",
	"Front-end Designer",
	"Back-end Designer",
	"Mobile App Tester",
	"Security Analyst",
	"Data Entry Specialist",
	"Systems Architect",
	"Database Architect",
	"IT Trainer",
	"Network Administrator",
	"Data Modeler",
	"QA Tester",
	"Technical Recruiter",
	"UI/UX Developer",
	"Digital Strategist",
	"Content Strategist",
	"Copywriter",
	"SEO Analyst",
	"Social Media Specialist",
	"Videographer",
	"Motion Graphics Designer",
	"Business Data Analyst",
	"Big Data Engineer",
	"Cloud Engineer",
	"IT Analyst",
	"Network Analyst",
	"Web Developer",
	"Mobile App Developer",
	"Game Designer",
	"Product Marketing Manager",
	"Sales Manager",
	"Account Executive",
	"Financial Manager",
	"HR Business Partner",
	"Operations Coordinator",
	"Supply Chain Manager",
	"Logistics Manager",
	"Procurement Manager",
	"Compliance Manager",
	"Legal Advisor",
	"Business Analyst Manager",
	"Operations Manager",
	"Customer Service Manager",
	"IT Security Manager",
	"UI/UX Designer",
	"Software Developer",
	"Database Administrator",
	"Systems Analyst",
	"IT Project Manager",
	"Cybersecurity Analyst",
	"Business Analyst",
	"QA Analyst",
	"Technical Writer",
	"Graphic Designer",
	"Content Writer",
	"Digital Marketer",
	"SEO Specialist",
	"Social Media Manager",
	"Video Editor",
	"Animator",
	"Data Analyst",
	"Machine Learning Engineer",
	"AI Specialist",
	"Blockchain Developer",
	"Cloud Architect",
	"IT Support Specialist",
	"Network Engineer",
	"Systems Administrator",
	"Database Developer",
	"IT Consultant",
	"Scrum Master",
	"Agile Coach",
	"Product Owner",
	"Project Coordinator",
	"Web Designer",
	"Mobile App Designer",
	"Game Developer",
	"IT Manager",
	"Technical Support Engineer",
	"Systems Engineer",
	"BI Analyst",
	"User Researcher",
	"Interaction Designer",
	"Marketing Manager",
	"Sales Representative",
	"Account Manager",
	"Financial Analyst",
	"HR Manager",
	"Operations Manager",
	"Supply Chain Analyst",
	"Logistics Coordinator",
	"Procurement Specialist",
	"Risk Analyst",
	"Compliance Officer",
	"Legal Counsel",
	"Business Development Manager",
	"Operations Analyst",
	"Customer Success Manager",
	"IT Auditor",
	"UI Developer",
	"Software Architect",
	"Data Engineer",
	"Product Analyst",
	"UX Researcher",
	"Front-end Designer",
	"Back-end Designer",
	"Mobile App Tester",
	"Security Analyst"
]
export{
	titles
}